import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";

const ManageBlogs = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const blogs = [
    {
      id: 1,
      title: "The Future of Electric Cars",
      image: "/static/images/placeholder.png",
      category: "Tips & Tricks for Buying Used Cars",
      authorName: "John Doe",
      publishedDate: "01-Sept-2023",
      status: true,
    },
    {
      id: 2,
      title: "Top 10 Car Maintenance Tips",
      image: "/static/images/placeholder.png",
      category: "Tips for Reducing Costs",
      authorName: "Jane Smith",
      publishedDate: "02-Sept-2023",
      status: true,
    },
    {
      id: 3,
      title: "Luxury SUVs Review",
      image: "/static/images/placeholder.png",
      category: "Commuter Allowance",
      authorName: "Mike Johnson",
      publishedDate: "03-Sept-2023",
      status: false,
    },
    {
      id: 4,
      title: "Eco-Friendly Driving Habits",
      image: "/static/images/placeholder.png",
      category: "Emission Standards",
      authorName: "Emily Davis",
      publishedDate: "04-Sept-2023",
      status: true,
    },
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>Blog Listings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          Blog Listings
        </p>
      </div>

      <div className="cards">
        {/* TABLE HEADER */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select fullWidth hiddenLabel defaultValue="default">
                  <MenuItem value="default" disabled>Select Category</MenuItem>
                  <MenuItem value="1">Tips & Tricks for Buying Used Cars</MenuItem>
                  <MenuItem value="2">Tips for Reducing Costs</MenuItem>
                  <MenuItem value="3">Misconceptions and Legal Situation</MenuItem>
                  <MenuItem value="4">Car, Truck, and Motorcycle Licenses</MenuItem>
                  <MenuItem value="5">Commuter Allowance</MenuItem>
                  <MenuItem value="6">Emission Standards</MenuItem>
                </Select>
              </div>
              <div className="control_group">
                <Select fullWidth hiddenLabel defaultValue="default">
                  <MenuItem value="default" disabled>Select Author</MenuItem>
                  <MenuItem value="1">John Doe</MenuItem>
                  <MenuItem value="2">Jane Smith</MenuItem>
                  <MenuItem value="3">Mike Johnson</MenuItem>
                  <MenuItem value="4">Emily Davis</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-blogs-listings/add")}
            >
              <AddIcon /> Add Blog
            </Button>
          </div>
        </div>

        {/* TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Detail</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Author Name</TableCell>
                <TableCell>Published Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {blogs.map((blog, index) => (
                <TableRow hover key={blog.id}>
                  {/* SR NO */}
                  <TableCell>{index + 1}</TableCell>

                  {/* DETAIL (Image and Title) */}
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src={blog.image} alt={blog.title} />
                      </figure>
                      <p>
                        <b>{blog.title}</b>
                      </p>
                    </div>
                  </TableCell>

                  {/* CATEGORY */}
                  <TableCell>{blog.category}</TableCell>

                  {/* AUTHOR NAME */}
                  <TableCell>{blog.authorName}</TableCell>

                  {/* PUBLISHED DATE */}
                  <TableCell>{blog.publishedDate}</TableCell>

                  {/* STATUS */}
                  <TableCell>
                    <SwitchToggle defaultChecked={blog.status} />
                  </TableCell>

                  {/* ACTIONS */}
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate("/manage-blogs-listings/detail")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="View"
                        />
                      </IconButton>
                      <IconButton onClick={() => navigate("/manage-blogs-listings/edit")}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageBlogs;
